import { Typography } from 'antd';
import React from 'react';
import styles from './TableCellText.module.less';

type Copyable = React.ComponentProps<typeof Typography.Text>['copyable'];

export default function TableCellText({
  children,
  copyable,
}: {
  children: string | number;
  copyable?: Copyable;
}) {
  const text = String(children);
  return (
    <span className={styles.cell}>
      <Typography.Text className={styles.text} ellipsis={{ tooltip: text }}>
        {children}
      </Typography.Text>
      {copyable && text && text !== '-' ? (
        <Typography.Text
          className={styles.copy}
          copyable={{
            text,
            ...(typeof copyable === 'object' ? copyable : {}),
          }}
        />
      ) : null}
    </span>
  );
}
